var _path, _polygon, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "382px",
    height: "512px",
    clipRule: "evenodd",
    fillRule: "evenodd",
    imageRendering: "optimizeQuality",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    viewBox: "0 0 29.93 40.02",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m5.21 0h13.38l11.34 11.82v22.99c0 2.88-2.33 5.21-5.2 5.21h-19.52c-2.88 0-5.21-2.33-5.21-5.21v-29.6c0-2.88 2.33-5.21 5.21-5.21z",
    fill: "#E5252A"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "18.58 0 18.58 11.73 29.93 11.73",
    fill: "#fff",
    fillOpacity: 0.30196
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m5.79 29.86v-7.31h3.11c0.77 0 1.38 0.21 1.84 0.64 0.46 0.42 0.69 0.99 0.69 1.7s-0.23 1.28-0.69 1.7c-0.46 0.43-1.07 0.64-1.84 0.64h-1.24v2.63h-1.87zm1.87-4.22h1.03c0.28 0 0.5-0.06 0.65-0.2 0.15-0.13 0.23-0.31 0.23-0.55s-0.08-0.42-0.23-0.55c-0.15-0.14-0.37-0.2-0.65-0.2h-1.03v1.5zm4.54 4.22v-7.31h2.59c0.51 0 0.99 0.07 1.44 0.22s0.86 0.36 1.22 0.65c0.36 0.28 0.65 0.66 0.86 1.14 0.2 0.48 0.31 1.03 0.31 1.65 0 0.61-0.11 1.16-0.31 1.64-0.21 0.48-0.5 0.86-0.86 1.14-0.36 0.29-0.77 0.5-1.22 0.65s-0.93 0.22-1.44 0.22h-2.59zm1.83-1.59h0.54c0.29 0 0.56-0.03 0.81-0.1 0.24-0.07 0.47-0.18 0.69-0.33 0.21-0.15 0.38-0.36 0.5-0.64s0.18-0.61 0.18-0.99c0-0.39-0.06-0.72-0.18-1s-0.29-0.49-0.5-0.64c-0.22-0.15-0.45-0.26-0.69-0.33-0.25-0.07-0.52-0.1-0.81-0.1h-0.54v4.13zm5.53 1.59v-7.31h5.2v1.59h-3.33v1.17h2.66v1.58h-2.66v2.97h-1.87z",
    fill: "#fff",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.6d848c286e7488bb655ff705569b2145.svg";
export { ForwardRef as ReactComponent };